import { render } from "./Article.vue?vue&type=template&id=73b35f90&scoped=true&lang=pug"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=73b35f90&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-73b35f90"

export default script